/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { UploadReimbursementRatesRequest } from '../models/UploadReimbursementRatesRequest';
import type { ValidateReimbursementRatesRequest } from '../models/ValidateReimbursementRatesRequest';
import type { ValidateReimbursementRatesResponse } from '../models/ValidateReimbursementRatesResponse';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class MileageReimbursementRateControllerv2Service {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param requestBody
     * @returns ValidateReimbursementRatesResponse
     * @throws ApiError
     */
    public mileageReimbursementRateControllerv2ValidateReimbursementRates(
        requestBody: Array<ValidateReimbursementRatesRequest>,
    ): Observable<ValidateReimbursementRatesResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/mileagereimbursementrates/validate',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public mileageReimbursementRateControllerv2UploadReimbursementRates(
        requestBody: Array<UploadReimbursementRatesRequest>,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/mileagereimbursementrates/upload',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
